import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'employeeboard'

const EmployeeboardModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default EmployeeboardModule



// WEBPACK FOOTER //
// ./src/store/module/employeeboard/index.js